import script from "./pending-transactions.vue?vue&type=script&setup=true&lang=js"
export * from "./pending-transactions.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__